// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3nQPt","col":"styles_col__1NAU8"};